import Cookies from 'js-cookie';

const $win = $(window);
const $doc = $(document);

export function closeBar () {
  $('.js-bar').slideUp();
  $('.header').removeClass('.js-bar-active');

  Cookies.set('announcement', true, { expires: 30 });
}

$doc.ready(function(){
  if (!Cookies.get('announcement')) {
    $('.js-bar').slideDown();
    $('.header').addClass('js-bar-active');
  }
})

$win.on('load scroll resize', function(){
  if ($('.js-bar-active').length !== 0) {
    $('.nav-mobile').css('margin-top', $('.js-bar').outerHeight() + 'px')
  } else {
    $('.nav-mobile').css('margin-top', 0);
  }
})